import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './Redux/Store';
import {BrowserRouter} from 'react-router-dom'
import {Provider} from 'react-redux'
import React from 'react';


const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(
  <BrowserRouter>
  <React.StrictMode>
  <Provider store={store}>
   
    <App />
  
  </Provider>
  </React.StrictMode> 
  </BrowserRouter>
  
);

